
var relatoriosList = [
    {
        path: "/relatorio/ProdutividadeAnalitico",
        name: "Relatório de Produtividade Analítico",
        permissao: "relatorio_produtividadeAnalitico"
    },
    {
        path: "/relatorio/ProdutividadeSintetico",
        name: "Relatório de Produtividade Sintético",
        permissao: "relatorio_produtividadeSintetico"
    },
    {
        path: "/relatorio/Inconformidades",
        name: "Relatório de Inconformidades", 
        permissao: "relatorio_inconformidades"
    },
    {
        path: "/relatorio/Ocorrencias",
        name: "Relatório de Ocorrências", 
        permissao: "relatorio_Ocorrencias"
    },
    {
        path: "/relatorio/AtendimentoAnalitico",
        name: "Relatório de Atendimento Analítico",
        permissao: "relatorio_atendimentoAnalitico"
    },
    {
        path: "/relatorio/AtendimentoSintetico",
        name: "Relatório de Atendimento Sintético",
        permissao: "relatorio_atendimentoSintetico"
    },
    {
        path: "/relatorio/QualidadeAnalitico",
        name: "Relatório de Qualidade Analítico", 
        permissao: "relatorio_qualidadeAnalitico"
    },
    {
        path: "/relatorio/QualidadeSintetico",
        name: "Relatório de Qualidade Sintético", 
        permissao: "relatorio_qualidadeSintetico"
    },
    {
        path: "/relatorio/HistoricoAtendimentoPontoColeta",
        name: "Relatório de Histórico de Atendimento dos Pontos de Coleta", 
        permissao: "relatorio_historicoAtendimentoPontoColeta"
    },
]

export default relatoriosList;